import CopyElection from './CopyElection';
export default CopyElection;
